
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TeamService } from '../shared/services/team.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
 
@Injectable({
  providedIn: 'root'
})
export class PortfolioGuard {

  constructor(private teamService: TeamService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const empIdStr = route.paramMap.get('empId');
    const link = route.paramMap.get('link');
    if (empIdStr) {
      const empId = Number(empIdStr); 
      return this.teamService.getActiveEmployeeStatus(empId).pipe(
        map(isActive => {
          if (isActive) {
            return true; 
          } else {
            if (link) {
              window.open(link, '_blank'); 
            } else {
              this.router.navigate(['/404']); 
            }
            return false; 
          }
        }),
        catchError(() => {
          if (link) {
            window.open(link, '_blank'); 
          } else {
            this.router.navigate(['/404']); 
          }
          return [false]; 
        })
      );
    } else if (link) {
      window.open(link, '_blank'); 
      return false;
    }
    this.router.navigate(['/404']);
    return false;
  }

  }